/** Overlay segment under the storefront catalog tab for the standards-only confirmation. */
export const STANDARDS_ONLY_CONFIRM_SEGMENT = "standards-only-confirm";
